/* eslint-disable
    guard-for-in,
    no-use-before-define,
    no-var,
*/
export default hintsCtrl

/** @ngInject */
function hintsCtrl(Hint, RoomName, $scope, smoothScroll, DeviceChecker, $timeout, hints, ErrorCatcher) {
    $scope.isMobile = () => DeviceChecker.isMobile()
    $scope.hintCategories = {
        'Se chauffer': {
            title: 'Se chauffer',
            hints: [],
            id: 'se-chauffer',
        },
        'Chauffer l’eau': {
            title: 'Chauffer l’eau',
            hints: [],
            id: 'chauffer-l-eau',
        },
        'Cuisiner': {
            title: 'Cuisiner',
            hints: [],
            id: 'cuisiner',
        },
        'Laver': {
            title: 'Laver',
            hints: [],
            id: 'laver',
        },
        'Refroidir': {
            title: 'Refroidir',
            hints: [],
            id: 'refroidir',
        },
        'Se divertir': {
            title: 'Se divertir',
            hints: [],
            id: 'se-divertir',
        },
        'S’éclairer': {
            title: 'S’éclairer',
            hints: [],
            id: 's-eclairer',
        },
        'Autres': {
            title: 'Autres',
            hints: [],
            id: 'autres',
        },
    }

    const flushHints = () =>
      (() => {
          const result = []
          for (const k in $scope.hintCategories) {
              const v = $scope.hintCategories[k]
              result.push(v.hints = [])
          }
          return result
      })()


    $scope.searchString = ''
    let timeOutPromise = null

    $scope.searchHint = function () {
        if (timeOutPromise) {
            $timeout.cancel(timeOutPromise)
        }
        timeOutPromise = $timeout(searchIt, 300)
    }

    const refreshHints = function (hints) {
        flushHints()
        return (() => {
            const result = []
            for (const hint of Array.from(hints)) {
                let item
                if ($scope.hintCategories[hint.category]) {
                    item = $scope.hintCategories[hint.category].hints.push(hint)
                }
                result.push(item)
            }
            return result
        })()
    }

    const searchIt = () =>
      Hint.getAll({ q: $scope.searchString }).$promise
      .then((response) => refreshHints(response))
      .catch(ErrorCatcher.catchError)

    refreshHints(hints)

    $scope.getHintClass = (room) => RoomName[room] || 'default'

    $scope.getHintClassDirective = (room) => (`${RoomName[room]}Icon`) || 'default'

    $scope.isLeft = (parentIndex) => (parentIndex % 2) === 0

    $scope.isRight = (parentIndex) => (parentIndex % 2) === 1

    $scope.readHint = function (hint, hintIndex, category) {
        const temp = category.hints[hintIndex]
        category.hints[hintIndex] = category.hints[0]
        category.hints[0] = temp
        return smoothScroll(document.getElementById(category.id), { offset: 30 })
    }
}



// WEBPACK FOOTER //
// ./src/states/hints/hints.js